"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataView = exports.PageTopContent = exports.FileList = exports.mapDispatchToProps = exports.mapStateToProps = exports.runningMan = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var moment = require("moment");
var classNames = require("classnames");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var recompose_1 = require("recompose");
var TypeLib = require("@caddigital/sok-types");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var viewport_1 = require("reducers/viewport");
var translate_1 = require("utils/translate");
require("./styles.scss");
var MetadataEditorActions = require("actions/metadataEditorModal");
var text_1 = require("utils/text");
var DatePicker_1 = require("components/DatePicker");
var download_1 = require("utils/download");
var avatars_1 = require("components/Avatar/avatars");
var Icon_1 = require("components/Icon");
var sokoproManIcon = (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_0');
exports.runningMan = '/assets/images/Business_man_run_cycle_transparent.gif';
var ENTER_KEYCODE = 13;
var TAB_KEYCODE = 9;
function convertRemToPixels(rem) {
    if (!document.documentElement) {
        return 0;
    }
    return (rem *
        parseFloat(getComputedStyle(document.documentElement).fontSize));
}
var TextElement = function (_a) {
    var key = _a.key, field = _a.field, value = _a.value, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: classNames('sok-metadata-row-column sok-text-input', disabled ? 'disabled' : '') },
        React.createElement("input", { type: "text", name: field, key: key, defaultValue: value, disabled: disabled, onBlur: function (e) { return onChange(e.target.value); }, onKeyDown: function (e) {
                if (e.keyCode === ENTER_KEYCODE) {
                    onChange(e.target.value);
                }
            } }),
        disabled ? (React.createElement("span", { className: 'input-lock' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is not editable.') },
                React.createElement("i", { className: 'fas fa-lock' })))) : null));
};
var CheckboxElement = function (_a) {
    var key = _a.key, field = _a.field, value = _a.value, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: classNames('sok-metadata-row-column sok-text-input', disabled ? 'disabled' : '') },
        React.createElement(sok_ui_1.Input, { type: "checkbox", name: field, key: key, disabled: disabled, value: value, onChange: function (e) {
                onChange(e.target.checked);
            } }),
        disabled ? (React.createElement("span", { className: 'input-lock' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is not editable.') },
                React.createElement("i", { className: 'fas fa-lock' })))) : null));
};
var MemoizedOptions = memoize(function (options) {
    return options
        .sort(function (a, b) { return a.order - b.order; })
        .map(function (x) { return (React.createElement("option", { key: x.name, value: x.value ? x.value : undefined }, x.name)); });
});
var SelectElement = function (_a) {
    var key = _a.key, field = _a.field, value = _a.value, options = _a.options, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: classNames('sok-metadata-row-column sok-text-input select', disabled ? 'disabled' : '') },
        React.createElement("select", { name: field, key: key, disabled: disabled, defaultValue: value, onChange: function (e) {
                if (value !== e.target.value) {
                    if (isNaN(e.target.value)) {
                        onChange(e.target.value);
                    }
                    else {
                        onChange(parseInt(e.target.value, 10));
                    }
                }
            } },
            React.createElement("option", { value: '' }),
            MemoizedOptions(options)),
        disabled ? (React.createElement("span", { className: 'input-lock' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is not editable.') },
                React.createElement("i", { className: 'fas fa-lock' })))) : null));
};
var DateElement = function (_a) {
    var value = _a.value, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: classNames('sok-metadata-row-column sok-text-input date', disabled ? 'disabled' : '') },
        React.createElement(DatePicker_1.DatePicker, { disabled: disabled, showTimeSelect: false, format: 'L', selected: value, onChange: onChange }),
        disabled ? (React.createElement("span", { className: 'input-lock' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is not editable.') },
                React.createElement("i", { className: 'fas fa-lock' })))) : null));
};
var DateTimeElement = function (_a) {
    var value = _a.value, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: classNames('sok-metadata-row-column sok-text-input date', disabled ? 'disabled' : '') },
        React.createElement(DatePicker_1.DatePicker, { timeCaption: (0, translation_1.getLocalization)('datePicker/time'), disabled: disabled, showTimeSelect: true, format: 'L LT', dateFormat: 'L HH:mm', selected: value, onChange: onChange }),
        disabled ? (React.createElement("span", { className: 'input-lock' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is not editable.') },
                React.createElement("i", { className: 'fas fa-lock' })))) : null));
};
var mapStateToProps = function (store) {
    var language = (0, translate_1.getLanguage)();
    return {
        displayPopup: store.metadataEditorModal.hasPreviousRevisions,
        token: store.auth.current.token,
        metadataEditorModal: store.metadataEditorModal,
        isMobile: (0, viewport_1.isMobile)(store.viewport),
        cart: store.cart.data,
        path: store.metadataEditorModal.path,
        language: language,
        location: store.router.location
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onFetchByFolderOrRevisions: function (uuid) {
        dispatch(MetadataEditorActions.fetchHierarchyRequest(uuid, 'REVISION_OR_FOLDER'));
    },
    onFetchBySession: function (uploadSessionUuid) {
        dispatch(MetadataEditorActions.fetchHierarchyRequest([uploadSessionUuid], 'SESSION'));
    },
    onEditMetadataRow: function (uuid, field) {
        dispatch(MetadataEditorActions.editMetadataRow(uuid, field));
    },
    onOverrideColumn: function (field) {
        var value = field.value;
        if (value === undefined) {
            value = null;
        }
        dispatch(MetadataEditorActions.overrideColumns({ key: field.key, value: value }));
    },
    onSave: function (meta) {
        return dispatch(MetadataEditorActions.saveMetadataFormRequest(meta));
    },
    onExport: function (token, files, includePath) {
        if (includePath === void 0) { includePath = false; }
        var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/exportcsv/exporting-title'), (0, translation_1.getLocalization)('files/toast/exportcsv/exporting-text'), 'NORMAL', [], undefined, 0));
        // export only files that are direcltly added to to editor
        var uuid = retVal.payload.uuid;
        var blockedPaths = {};
        var filesToBeExported = [];
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if (blockedPaths[file.parent]) {
                blockedPaths[file.id] = true;
                continue;
            }
            blockedPaths[file.id] = true;
            filesToBeExported.push(file);
        }
        (0, download_1.exportCSVFromFiles)(token, filesToBeExported, [], {
            includeSubFolders: 'true',
            includeSelf: 'true',
            includePath: includePath === true ? 'true' : 'false'
        }, undefined, function () { return dispatch(ToastActions.removeToast(uuid)); });
    },
    onImport: function (file) {
        return dispatch(MetadataEditorActions.importMetadataRequest(file));
    },
    goBack: function () {
        dispatch((0, connected_react_router_1.goBack)());
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var getTypeIcon = memoize(function (type) {
    switch (type) {
        case 'FOLDER':
            return React.createElement(Icon_1.Icon, { className: 'fa-folder' });
        case 'SPREADSHEET':
            return React.createElement(Icon_1.Icon, { className: 'icofont-file-spreadsheet' });
        case 'TEXT':
            return React.createElement(Icon_1.Icon, { className: 'icofont-file-text' });
        case 'IFC':
            return React.createElement(Icon_1.Icon, { className: 'sok-icon-ifc' });
        case 'DWG':
            return React.createElement(Icon_1.Icon, { className: 'sok-icon-dwg' });
        case 'PDF':
            return React.createElement(Icon_1.Icon, { className: 'icofont-file-pdf' });
        case 'IMAGE':
            return React.createElement(Icon_1.Icon, { className: 'icofont-file-jpg' });
        case 'POWERPOINT':
            return React.createElement(Icon_1.Icon, { className: 'icofont-file-powerpoint' });
        default:
            return React.createElement(Icon_1.Icon, { className: 'fa-file' });
    }
});
var getFormattedStringLength = memoize(function (s, maxlen) {
    return s.length > maxlen ? s.substr(0, maxlen) + '...' : s;
});
var getFormattedPath = function (absPath) {
    var parsedPath = absPath.endsWith('/')
        ? absPath.substring(0, absPath.length - 1)
        : absPath;
    var arr = parsedPath.split('/');
    var len = arr.length;
    if (arr[Math.max(0, arr.length - 1)].length > 50) {
        arr[Math.max(0, arr.length - 1)] = getFormattedStringLength(arr[Math.max(0, arr.length - 1)], 32);
    }
    if (len < 6 && parsedPath.length < 60) {
        return parsedPath;
    }
    var first = arr[0];
    var last = arr[len - 2];
    if (!last) {
        return getFormattedStringLength(absPath, 64);
    }
    return [
        first ? getFormattedStringLength(first, 16) : '',
        '...',
        last ? getFormattedStringLength(last, 16) : '',
        arr[len - 1]
    ].join('/');
};
var metadataPopupEnhance = (0, recompose_1.compose)((0, recompose_1.onlyUpdateForKeys)(['isOpen']), recompose_1.pure);
var PreviousVersionPopup = metadataPopupEnhance(function (props) { return (React.createElement("div", { className: classNames('popup metadata-validation-error', props.isOpen ? 'open' : '') },
    React.createElement("div", { className: "sokopro-man-wrap" },
        React.createElement("img", { className: "sokopro-man", src: sokoproManIcon })),
    React.createElement("div", { className: "arrow" }),
    React.createElement("div", { className: "description previous-version" },
        React.createElement("span", null, "".concat((0, translation_1.getLocalization)('metadataeditor/dearsokoprouser'), " ").concat((0, translation_1.getLocalization)('metadataeditor/popup/previousversionfound')))),
    React.createElement("div", { className: "close-icon", onClick: props.onClose }, "x"))); });
var SessionCompletedPopup = metadataPopupEnhance(function (props) { return (React.createElement("div", { className: classNames('popup metadata-validation-error', props.isOpen ? 'open' : '') },
    React.createElement("div", { className: "sokopro-man-wrap" },
        React.createElement("img", { className: "sokopro-man", src: sokoproManIcon })),
    React.createElement("div", { className: "arrow" }),
    React.createElement("div", { className: "description session-completed" },
        React.createElement("span", null, "".concat((0, translation_1.getLocalization)('metadataeditor/dearsokoprouser'), " ").concat((0, translation_1.getLocalization)('metadataeditor/popup/success')))),
    React.createElement("div", { className: "close-icon", onClick: props.onClose }, "x"))); });
var ValidationErrorPopup = metadataPopupEnhance(function (props) { return (React.createElement("div", { className: classNames('popup metadata-validation-error', props.isOpen ? 'open' : '') },
    React.createElement("div", { className: "sokopro-man-wrap" },
        React.createElement("img", { className: "sokopro-man", src: sokoproManIcon })),
    React.createElement("div", { className: "arrow" }),
    React.createElement("div", { className: "description validation-error" },
        React.createElement("span", null, "".concat((0, translation_1.getLocalization)('metadataeditor/popup/validationerror')))),
    React.createElement("div", { className: "close-icon", onClick: props.onClose }, "x"))); });
var MandatoryFieldsPopup = metadataPopupEnhance(function (props) { return (React.createElement("div", { className: classNames('popup metadata-validation-error', props.isOpen ? 'open' : '') },
    React.createElement("div", { className: "sokopro-man-wrap" },
        React.createElement("img", { className: "sokopro-man", src: sokoproManIcon })),
    React.createElement("div", { className: "arrow" }),
    React.createElement("div", { className: "description mandatory-fields" },
        React.createElement("span", null, (0, translation_1.getLocalization)('metadataeditor/popup/mandatoryfields'))),
    React.createElement("div", { className: "close-icon", onClick: props.onClose }, "x"))); });
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('popup', 'setPopup', 'NONE'), (0, recompose_1.withState)('displayLocked', 'setDisplayLocked', false), (0, recompose_1.withState)('statusText', 'setStatusText', ''), (0, recompose_1.withState)('status', 'setStatus', 'IDLE'), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var props = this.props;
        if (props.sessionUuid && props.sessionUuid !== '') {
            props.onFetchBySession && props.onFetchBySession(props.sessionUuid);
        }
        else if (props.cart.items.length > 0) {
            props.onFetchByFolderOrRevisions &&
                props.onFetchByFolderOrRevisions(props.cart.items.map(function (x) { return x.uuid; }));
        }
        if (props.metadata &&
            props.metadata.status === 'FETCHED' &&
            props.metadata.list.findIndex(function (m) { return m.required === true; }) > -1) {
            props.setPopup('MANDATORY_FIELDS');
        }
    },
    componentWillReceiveProps: function (nextProps) {
        var props = this.props;
        var status = nextProps.metadataEditorModal.status;
        if (this.props.metadataEditorModal.status === 'STANDBY' &&
            this.props.metadataEditorModal.status ===
                nextProps.metadataEditorModal.status &&
            (props.sessionUuid === undefined || props.sessionUuid === '') &&
            this.props.cart.items.length === 0 &&
            nextProps.cart.items.length > 0) {
            props.onFetchByFolderOrRevisions(nextProps.cart.items.map(function (x) { return x.uuid; }));
        }
        if (this.props.metadataEditorModal.status !==
            nextProps.metadataEditorModal.status) {
            if (status === 'FETCHING') {
                nextProps.setStatus('SENDING');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/fetching')); // 'Loading...'
            }
            else if (status === 'SAVING') {
                nextProps.setStatus('SENDING');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/saving')); // 'Saving...'
            }
            else if (status === 'FETCHED') {
                nextProps.setStatus('SUCCEEDED');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/fetched')); // 'Fetched!'
            }
            else if (status === 'SAVED') {
                nextProps.setStatus('SUCCEEDED');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/saved')); // 'Saved!'
            }
            else if (status === 'ERROR' || status === 'VALIDATION_ERROR') {
                nextProps.setStatus('FAILED');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/failed')); // 'Error!'
            }
            else if (status === 'IMPORTING') {
                nextProps.setStatus('SENDING');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/importing'));
            }
            else if (status === 'IMPORTING_ERROR') {
                nextProps.setStatus('FAILED');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/importing_failed'));
            }
            else if (status === 'IMPORTING_SUCCESS') {
                nextProps.setStatus('SUCCEEDED');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/importing_success'));
            }
            else if (status === 'IMPORTING_SUCCESS_WITH_INVALID_DATA') {
                nextProps.setStatus('SUCCEEDED');
                nextProps.setStatusText((0, translation_1.getLocalization)('metadataeditor/notification/importing_success_with_invalid_fields'));
            }
        }
        if (nextProps.metadataEditorModal.timesSaved === 1 &&
            nextProps.metadataEditorModal.timesSaved !==
                props.metadataEditorModal.timesSaved &&
            nextProps.metadataEditorModal.type === 'SESSION') {
            nextProps.setPopup('SESSION_COMPLETED');
            return;
        }
        if (props.metadataEditorModal.failedColumns !==
            nextProps.metadataEditorModal.failedColumns) {
            if (nextProps.metadataEditorModal.failedColumns.length > 0) {
                nextProps.setPopup('VALIDATION');
            }
            else if (nextProps.popup === 'VALIDATION') {
                nextProps.setPopup('NONE');
            }
            return;
        }
        if (nextProps.metadataEditorModal.type === 'SESSION' &&
            nextProps.metadataEditorModal.hasPreviousRevisions === true &&
            nextProps.popup !== 'VALIDATION' &&
            nextProps.popup !== 'SESSION_COMPLETED' &&
            nextProps.popup !== 'PREVIOUS_VERSION' &&
            nextProps.popup !== 'NONE') {
            nextProps.setPopup('PREVIOUS_VERSION');
            return;
        }
    }
}));
// Helper function memoizes props to avoid unnecessary re-renders of Row component.
var createRowData = memoize(function (metaDataColumns, selectedLanguage, getLocalization, items, errors, onChange, displayLocked, currentProject, uuid) { return ({
    metaDataColumns: metaDataColumns,
    selectedLanguage: selectedLanguage,
    getLocalization: getLocalization,
    items: items,
    errors: errors,
    onChange: onChange,
    displayLocked: displayLocked,
    currentProject: currentProject,
    uuid: uuid
}); });
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, errors = data.errors, onChange = data.onChange, displayLocked = data.displayLocked;
    var row = items[index];
    var type = row.type.toUpperCase();
    var error = errors[row.uuid];
    var values = row.customMeta.reduce(function (prev, c) {
        if (c.type === 'dependant-select') {
            var val = c.options
                ? c.options.find(function (o) { return o.name === c.value || o.value === c.value; })
                : undefined;
            if (val) {
                prev[c.id] = val.value;
            }
        }
        return prev;
    }, {});
    return (React.createElement("div", { style: style, className: classNames('row', index % 2 !== 0 ? 'white' : 'gray', type !== 'FOLDER' ? 'file' : '', row.type !== 'FOLDER' && row.version > 1 ? 'previous-version' : '') },
        React.createElement("div", { className: classNames('row__column __namemeta content-row', type === 'FOLDER' ? 'bold' : '') },
            getTypeIcon(row.type),
            type === 'FOLDER' ? (React.createElement("span", null,
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, row.path) },
                    React.createElement("span", null, row.path ? getFormattedPath(row.path) : row.name)))) : (React.createElement("span", null,
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, row.path ? row.path : row.name) },
                    React.createElement("span", null, getFormattedStringLength(row.name, 60)))))),
        row.customMeta &&
            row.customMeta.reduce(function (p, v, k) {
                if (v.identifier === 'name-meta')
                    return p;
                var columnName = v.identifier.replace(/-/g, '');
                var type = v.type;
                var options = [];
                if (type === 'dependant-select') {
                    options = (v.options || []).filter(function (o) {
                        return o.references === null ||
                            (o.references &&
                                v.parent &&
                                values[v.parent] === o.references);
                    });
                }
                else if (type === 'select') {
                    options = v.options || [];
                }
                var hideField = (!v.editable && !displayLocked) ||
                    (v.bitField & TypeLib.CustomMeta.FILES_LIST) === 0;
                p.push(React.createElement("div", { className: classNames('row__column', v.type, error && error[v.identifier] === true ? 'error' : '', "__".concat(columnName), hideField && 'locked') }, (function (v) {
                    var disabled = !v.editable;
                    switch (type) {
                        case 'dependant-select':
                        case 'select':
                            return SelectElement({
                                key: row.uuid + v.identifier + v.value,
                                value: v.formattedValue,
                                field: v.identifier,
                                options: options,
                                disabled: disabled,
                                onChange: function (value) {
                                    return onChange(row.uuid, { key: k, value: value });
                                }
                            });
                        case 'checkbox':
                            return CheckboxElement({
                                key: row.uuid +
                                    v.identifier +
                                    (v.value ? v.value.toString() : ''),
                                value: v.formattedValue,
                                field: v.identifier,
                                disabled: disabled,
                                onChange: function (value) {
                                    return onChange(row.uuid, { key: k, value: value });
                                }
                            });
                        case 'day':
                            return DateElement({
                                key: row.uuid + v.identifier + v.value,
                                value: v.formattedValue,
                                field: v.identifier,
                                disabled: disabled,
                                onChange: function (value) {
                                    return onChange(row.uuid, { key: k, value: value });
                                }
                            });
                        case 'datetime':
                            return DateTimeElement({
                                key: row.uuid + v.identifier + v.value,
                                value: v.formattedValue,
                                field: v.identifier,
                                disabled: disabled,
                                onChange: function (value) {
                                    return onChange(row.uuid, { key: k, value: value });
                                }
                            });
                        case 'text':
                        default:
                            return TextElement({
                                key: row.uuid + v.identifier + v.value,
                                value: v.formattedValue,
                                field: v.identifier,
                                disabled: disabled,
                                onChange: function (value) {
                                    return onChange(row.uuid, { key: k, value: value });
                                }
                            });
                    }
                })(v)));
                return p;
            }, [])));
});
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return nextProps.values !== props.values ||
        (0, List_1.shallowDiffers)(nextProps.failedColumns, props.failedColumns) ||
        (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        nextProps.metaDataColumns !== props.metaDataColumns ||
        nextProps.contentWidth !== props.contentWidth;
}), (0, recompose_1.withState)('values', 'setValues', {}));
var HeaderColumn = function (_a) {
    var column = _a.column, value = _a.value, values = _a.values, setValue = _a.setValue, hasError = _a.hasError, onClick = _a.onClick, displayLocked = _a.displayLocked;
    var columnName = column.identifier.replace(/-/g, '');
    var hideField = (!column.editable && !displayLocked) ||
        (column.bitField & TypeLib.CustomMeta.FILES_LIST) === 0;
    return (React.createElement("div", { className: classNames('row__column', column.type, hasError ? 'error' : '', "__".concat(columnName), hideField && 'locked') },
        React.createElement("div", { className: 'sok-header-text' },
            React.createElement("div", { className: 'text' },
                React.createElement("span", { className: 'name' }, column.name),
                React.createElement("div", { className: 'icons' },
                    hasError ? (React.createElement("span", { className: 'error' },
                        React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Validation error.') },
                            React.createElement(Icon_1.Icon, { className: 'fa-exclamation-triangle' })))) : null,
                    !column.editable && (React.createElement("span", { className: 'mandatory' },
                        React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is not editable.') },
                            React.createElement("i", { className: 'fas fa-lock' })))),
                    column.required === true && (React.createElement("span", { className: 'mandatory' },
                        React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, 'Field is required.') },
                            React.createElement("i", { className: 'fas fa-asterisk' }))))))),
        React.createElement("div", { className: 'btn-populate-wrap' },
            React.createElement("div", { className: classNames('sok-text-input', column.type, !column.editable ? 'disabled' : '') }, (function (type, opts) {
                var disabled = !column.editable;
                var options = [];
                if (type === 'dependant-select') {
                    options = (opts || []).filter(function (o) {
                        return o.references === null ||
                            (o.references &&
                                column.parent &&
                                values[column.parent] === o.references);
                    });
                }
                else if (type === 'select') {
                    options = opts || [];
                }
                switch (type) {
                    case 'checkbox':
                        return (React.createElement(sok_ui_1.Input, { disabled: disabled, value: value, type: "checkbox", onChange: function (e) {
                                setValue(!value);
                            }, onKeyDown: function (e) {
                                if (e.keyCode === ENTER_KEYCODE) {
                                    setValue(e.target.value);
                                    onClick({
                                        key: column.identifier,
                                        value: e.target.value
                                    });
                                }
                            } }));
                    case 'dependant-select':
                    case 'select':
                        return (React.createElement("select", { disabled: disabled, onChange: function (e) {
                                var value = e.target.value;
                                if (column.type === 'select' ||
                                    column.type === 'dependant-select' ||
                                    column.type === 'radio') {
                                    value = isNaN(value) ? value : parseInt(value, 10);
                                }
                                setValue(value);
                            }, onKeyDown: function (e) {
                                if (e.keyCode === ENTER_KEYCODE) {
                                    var value_1 = e.target.value;
                                    if (column.type === 'select' ||
                                        column.type === 'dependant-select' ||
                                        column.type === 'radio') {
                                        value_1 = isNaN(value_1) ? value_1 : parseInt(value_1, 10);
                                    }
                                    setValue(value_1);
                                    onClick({
                                        key: column.identifier,
                                        value: value_1
                                    });
                                }
                            } },
                            React.createElement("option", { value: '' }),
                            MemoizedOptions(options || [])));
                    case 'day':
                        return (React.createElement(DatePicker_1.DatePicker, { disabled: disabled, showTimeSelect: false, format: 'L', selected: value, onChange: function (date) { return setValue(date); }, onKeyDown: function (e) {
                                if (e.keyCode === ENTER_KEYCODE) {
                                    setValue(e.target.value);
                                    onClick({
                                        key: column.identifier,
                                        value: e.target.value
                                    });
                                }
                            } }));
                    case 'datetime':
                        return (React.createElement(DatePicker_1.DatePicker, { timeCaption: (0, translation_1.getLocalization)('datePicker/time'), disabled: disabled, showTimeSelect: true, format: 'L LT', selected: value, onChange: function (date) { return setValue(date); }, onKeyDown: function (e) {
                                if (e.keyCode === ENTER_KEYCODE) {
                                    setValue(e.target.value);
                                    onClick({
                                        key: column.identifier,
                                        value: e.target.value
                                    });
                                }
                            } }));
                    case 'text':
                    default:
                        return (React.createElement("input", { disabled: disabled, type: "text", onInput: function (e) {
                                if (e.keyCode === ENTER_KEYCODE) {
                                    setValue(e.target.value);
                                    onClick({
                                        key: column.identifier,
                                        value: e.target.value
                                    });
                                }
                                setValue(e.target.value);
                            } }));
                }
            })(column.type, column.options)),
            React.createElement("div", { className: 'btn-populate' },
                React.createElement(Icon_1.Icon, { className: 'fa fa-level-down-alt', onClick: function () {
                        !!column.editable &&
                            onClick({ key: column.identifier, value: value });
                    } })))));
};
var Header = enhanceHeader(function (_a) {
    var values = _a.values, setValues = _a.setValues, style = _a.style, metaDataColumns = _a.metaDataColumns, failedColumns = _a.failedColumns, onOverrideColumn = _a.onOverrideColumn, displayLocked = _a.displayLocked;
    return (React.createElement("div", { style: style, className: 'header row' },
        React.createElement("div", { className: "row__column __namemeta" },
            React.createElement("span", null, (0, translation_1.getLocalization)('metadataeditor/header/filename'))),
        metaDataColumns
            .filter(function (column) {
            return column.identifier !== 'name-meta';
        })
            .map(function (column) { return (React.createElement(HeaderColumn, { column: column, values: values, setValue: function (value) {
                var optionValues = __assign({}, values);
                if (column.id) {
                    optionValues[column.id] = value;
                }
                setValues(column.id ? optionValues : value);
            }, value: column.id ? values[column.id] : values, hasError: failedColumns.indexOf(column.identifier) > -1, onClick: onOverrideColumn, displayLocked: displayLocked })); })));
});
var PADDING_SIZE = convertRemToPixels(1.2);
var enhanceList = (0, recompose_1.compose)((0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.setContentWidth(0);
    },
    componentWillReceiveProps: function (nextProps) {
        var props = this.props;
        if ((0, List_1.shallowDiffers)(nextProps.items, this.props.items) ||
            (0, List_1.shallowDiffers)(nextProps.metaDataColumns, this.props.metaDataColumns) ||
            nextProps.contentWidth !== this.props.contentWidth ||
            nextProps.contentWidth === 0 ||
            nextProps.displayLocked !== this.props.displayLocked) {
            var contentWidth_1 = 0;
            var columns_1 = nextProps.items.reduce(function (p, item) {
                item.customMeta &&
                    item.customMeta.forEach(function (c) {
                        if (c.identifier === 'uuid' || c.identifier === 'name-meta') {
                            return;
                        }
                        if ((!nextProps.displayLocked && !c.editable) ||
                            (c.bitField & TypeLib.CustomMeta.FILES_LIST) === 0) {
                            return;
                        }
                        var dataKey = '__' + c.identifier.replace(/-/g, '');
                        var text = c.value ? c.value.toString() : '';
                        var prevValue = p[dataKey];
                        var fieldLength;
                        switch (c.type) {
                            case 'checkbox':
                                fieldLength = 20;
                                break;
                            case 'day':
                            case 'datetime':
                            case 'select':
                            case 'dependant-select':
                                fieldLength = 164;
                                break;
                            default:
                                fieldLength = Math.max(164, Math.min(230, (0, text_1.calculateStringLength)(text)));
                        }
                        var length = fieldLength;
                        if (prevValue && prevValue.length < length) {
                            prevValue.text = text;
                            prevValue.length = length;
                        }
                        else if (!prevValue) {
                            p[dataKey] = {
                                text: text,
                                length: length
                            };
                        }
                    });
                return p;
            }, {});
            nextProps.metaDataColumns.forEach(function (x) {
                if ((!nextProps.displayLocked && !x.editable) ||
                    (x.bitField & TypeLib.CustomMeta.FILES_LIST) === 0) {
                    return;
                }
                if (x.identifier === 'uuid')
                    return;
                var dataKey = '__' + x.identifier.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)(x.name.toString()).toString();
                var length = (0, text_1.calculateStringLength)(text);
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue.length < length) {
                    prevValue.text = text;
                    prevValue.length = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = {
                        text: text,
                        length: length
                    };
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            nextProps.items.forEach(function (item) {
                var nameLength = (0, text_1.calculateStringLength)(item.type === 'FOLDER' && item.path
                    ? getFormattedPath(item.path)
                    : getFormattedStringLength(item.name, 60));
                if (!lengths_1['__namemeta'] || lengths_1['__namemeta'] < nameLength) {
                    lengths_1['__namemeta'] = nameLength + 36;
                }
            });
            // Override styles for dynamic classes
            var style = document.getElementById('FilesListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'FilesListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 36;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 36); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            nextProps.setContentWidth(contentWidth_1 + PADDING_SIZE * Object.keys(lengths_1).length);
        }
    }
}));
exports.FileList = enhanceList(function (props) {
    // memoize item props into props.data object
    var itemData = createRowData(props.metaDataColumns, props.selectedLanguage, props.getLocalization, props.items, props.errors, props.onChange, props.displayLocked, props.currentProject, props.uuid);
    return (React.createElement("div", { className: 'metadata-view-list-container' },
        React.createElement("div", { className: 'metadata-view-list' },
            React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, headerHeight: 80, itemHeight: 52, itemWidth: props.contentWidth, onScroll: function () {
                        var e = document.activeElement;
                        if (e) {
                            ;
                            e.blur();
                        }
                    }, header: React.createElement(Header, { metaDataColumns: props.metaDataColumns, failedColumns: props.failedColumns, onOverrideColumn: props.onOverrideColumn, displayLocked: props.displayLocked }) }, ListRow));
            }))));
});
var PageTopContentEnhance = (0, recompose_1.compose)((0, recompose_1.onlyUpdateForKeys)(['statusText', 'path']), recompose_1.pure);
exports.PageTopContent = PageTopContentEnhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(props.BreadCrumb, { filtering: 'NONE', path: props.path, currentProject: props.currentProject, currentBid: props.currentBid, currentBriefcase: props.currentBriefcase }),
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.status, statusList: ['IDLE', 'SENDING', 'SUCCEEDED', 'FAILED'] },
            React.createElement("span", null, props.statusText),
            React.createElement("span", null, props.statusText),
            React.createElement("span", null, props.statusText))));
});
exports.MetadataView = enhance(function (props) {
    return (React.createElement("div", { className: "content-wrapper-content" },
        React.createElement("div", { className: classNames('metadata-editor-view', props.metadataEditorModal.type === 'SESSION' && 'session'), onKeyDown: function (e) {
                if (e.which === ENTER_KEYCODE) {
                    var metas = props.metadataEditorModal.dirtyColumns;
                    var type = props.metadataEditorModal.type;
                    if (type === 'SESSION' && props.sessionUuid) {
                        return props.onSave({
                            metas: metas,
                            hierarchyType: 'SESSION',
                            sessionUuid: props.sessionUuid
                        });
                    }
                    return props.onSave({
                        metas: metas,
                        hierarchyType: 'REVISION_OR_FOLDER',
                        uuids: props.metadataEditorModal.files.map(function (x) { return x.uuid; })
                    });
                }
            } },
            React.createElement(exports.PageTopContent, { BreadCrumb: props.BreadCrumb, currentBid: props.currentBid, currentBriefcase: props.currentBriefcase, currentProject: props.currentProject, path: props.path, status: props.status, statusText: props.statusText }),
            React.createElement("main", { className: 'content' },
                React.createElement("div", { className: 'title' },
                    props.metadataEditorModal.status !== 'ERROR' &&
                        props.metadataEditorModal.status !== 'FETCHING' ? (React.createElement("div", null,
                        React.createElement(PreviousVersionPopup, { isOpen: props.popup === 'PREVIOUS_VERSION', onClose: function () { return props.setPopup('NONE'); } }),
                        React.createElement(ValidationErrorPopup, { isOpen: props.popup === 'VALIDATION', onClose: function () { return props.setPopup('NONE'); } }),
                        React.createElement(MandatoryFieldsPopup, { isOpen: props.popup === 'MANDATORY_FIELDS', onClose: function () { return props.setPopup('NONE'); } }),
                        React.createElement(SessionCompletedPopup, { isOpen: props.popup === 'SESSION_COMPLETED', onClose: function () { return props.setPopup('NONE'); } }))) : null,
                    React.createElement(Icon_1.Icon, { className: 'fa-list' }),
                    React.createElement("h2", null, (0, translation_1.getLocalization)('metdataeditor/title'))),
                React.createElement("div", { className: "metadata-editor-top" }),
                props.metadataEditorModal.status === 'ERROR' && (React.createElement("div", { className: 'loading-view' },
                    React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('metadataeditor/dearsokoprouser') }, (0, translation_1.getLocalization)('metadataeditor/errorfetching')))),
                props.metadataEditorModal.status === 'FETCHING' && (React.createElement("div", { className: 'loading-view' },
                    React.createElement("img", { className: "icon", src: exports.runningMan }),
                    React.createElement("span", { className: 'status-text' },
                        React.createElement("strong", null, (0, translation_1.getLocalization)('metadataeditor/dearsokoprouser')),
                        ' ',
                        (0, translation_1.getLocalization)('metadataeditor/pleasewait')))),
                props.metadataEditorModal.files.length > 0 &&
                    props.metadataEditorModal.status !== 'FETCHING' &&
                    props.metadataEditorModal.status !== 'ERROR' && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'display-locked-metas-selection' },
                        React.createElement(sok_ui_1.Input, { type: 'checkbox', name: 'displayLocked', label: (0, translation_1.getLocalization)('metadataeditor/showMetas'), defaultChecked: false, onChange: function () {
                                return props.setDisplayLocked(!props.displayLocked);
                            } })),
                    React.createElement(exports.FileList, { getLocalization: translation_1.getLocalization, selectedLanguage: (0, translate_1.getLanguage)(), metaDataColumns: props.metadata.status === 'FETCHED'
                            ? props.metadata.list
                            : [], items: props.metadataEditorModal.files, failedColumns: props.metadataEditorModal.failedColumns || [], errors: props.metadataEditorModal.errRows, currentProject: props.currentProject, onChange: props.onEditMetadataRow, onOverrideColumn: props.onOverrideColumn, displayLocked: props.displayLocked })))),
            React.createElement("div", { className: 'metaview-footer' },
                React.createElement("div", { className: 'metadata-editor-buttons' },
                    React.createElement("div", { className: 'last-saved' }, props.metadataEditorModal.timesSaved > 0 &&
                        props.metadataEditorModal.lastSaved ? (React.createElement("span", null, "".concat((0, translation_1.getLocalization)('metadtaeditor/lastsaved'), ": ").concat(moment(props.metadataEditorModal.lastSaved).format('L LTS')))) : null),
                    props.metadataEditorModal.status !== 'FETCHING' &&
                        props.metadataEditorModal.status !== 'ERROR' && (React.createElement(sok_ui_1.Button, { color: 'blue', size: 'medium', onClick: function () {
                            var input = document.createElement('input');
                            input.setAttribute('type', 'file');
                            input.onchange = function (e) {
                                if (e.target && e.target.files && e.target.files[0]) {
                                    props.onImport(e.target.files[0]);
                                }
                            };
                            input.click();
                        }, icon: React.createElement("i", { className: 'fas fa-file-excel' }), className: 'import-excel' }, (0, translation_1.getLocalization)('metadataeditor/importcsv'))),
                    props.metadataEditorModal.status !== 'FETCHING' &&
                        props.metadataEditorModal.status !== 'ERROR' &&
                        ((props.metadataEditorModal.type === 'SESSION' &&
                            props.metadataEditorModal.timesSaved > 0) ||
                            props.metadataEditorModal.type === 'REVISION_OR_FOLDER') && (React.createElement(sok_ui_1.Button, { onClick: function () {
                            if (props.metadataEditorModal.type === 'SESSION') {
                                props.onExport(props.token, props.metadataEditorModal.files);
                                return;
                            }
                            props.onExport(props.token, props.cart.items, true);
                        }, color: "blue", size: 'medium', icon: React.createElement("i", { className: 'fas fa-file-excel' }), className: 'export-to-excel' }, (0, translation_1.getLocalization)('metadataeditor/exportcsv'))),
                    props.metadataEditorModal.status !== 'FETCHING' &&
                        props.metadataEditorModal.status !== 'ERROR' && (React.createElement(sok_ui_1.Button, { color: "green", size: 'medium', disabled: props.metadataEditorModal.status === 'SAVING', icon: props.metadataEditorModal.status === 'SAVING' ? (React.createElement(Icon_1.Icon, { className: 'fa-spinner fa-spin' })) : null, onClick: function () {
                            var metas = props.metadataEditorModal.dirtyColumns;
                            if (props.metadataEditorModal.type === 'SESSION' &&
                                props.sessionUuid) {
                                return props.onSave({
                                    metas: metas,
                                    hierarchyType: 'SESSION',
                                    sessionUuid: props.sessionUuid
                                });
                            }
                            return props.onSave({
                                metas: metas,
                                hierarchyType: 'REVISION_OR_FOLDER',
                                uuids: props.metadataEditorModal.files.map(function (x) { return x.uuid; })
                            });
                        } }, props.metadataEditorModal.status === 'SAVING'
                        ? (0, translation_1.getLocalization)('metadataeditor/saving')
                        : (0, translation_1.getLocalization)('metadataeditor/save'))),
                    props.metadataEditorModal.isExportable ||
                        props.metadataEditorModal.timesSaved > 0 ? (React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('metadataeditor/close'), disabled: props.metadataEditorModal.status === 'SAVING', size: 'medium', onClick: function () {
                            props.goBack();
                        } })) : (React.createElement(sok_ui_1.Button, { color: "red", text: (0, translation_1.getLocalization)('metadataeditor/cancel'), size: 'medium', onClick: function () {
                            props.goBack();
                        } })))))));
});
exports.default = exports.MetadataView;
